import React from 'react'
import { Theme, makeStyles } from '@material-ui/core/styles'
import { Sort } from '@src/types/graphql-types'
import clsx from 'clsx'
import CaretDownIcon from '@src/icons/CaretDownIcon'

export enum SortBySize {
  Small = 'sm',
  Medium = 'md',
}
interface SortByIconProps {
  sortBy: [Sort, string]
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    sortIcons: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.primary.main,
      '& svg': {
        width: '10px',
      },
    },
    sortIcon: {
      cursor: 'pointer',
    },
    upArrow: {
      transform: 'rotate(180deg)',
    },
  }
})

const SortByIcon: React.FC<SortByIconProps> = ({ sortBy }) => {
  const classes = useStyles()

  return (
    <div className={classes.sortIcons}>
      {sortBy[0] === Sort.Nameasc ? (
        <CaretDownIcon
          aria-label="Sort descending"
          role="button"
          className={clsx(classes.sortIcon, classes.upArrow)}
        />
      ) : (
        <CaretDownIcon
          aria-label="Sort ascending"
          role="button"
          className={clsx(classes.sortIcon)}
        />
      )}
    </div>
  )
}
export default SortByIcon
